import { Component, OnInit, Input, HostBinding, ViewChild, ElementRef, HostListener } from '@angular/core';
import { IPictureData } from 'src/app/shared/components/picture/picture.component';
import { IUProperty } from 'src/app/shared/interface/umbraco-property';
import { ILinkWithColor } from 'src/app/shared/interface/link';
import { AnimationOptions } from 'ngx-lottie';
import { applyTitleSettings } from '../../shared/utils/title-style-settings-utils';
import { ITitleStyleSettings } from '../../shared/interface/title-style-settings';
import { IRteStyleSettings } from "../../shared/interface/rte-style-settings";
import { applyRteSettings } from '../../shared/utils/rte-style-settings-utils';

interface IRtePanelData {
  title?: IUProperty<string>,
  description?: IUProperty<string>,
  backgroundImage?: IUProperty<IPictureData>;
  animationUrl?: IUProperty<string>;
  links?: IUProperty<ILinkWithColor[]>;
  backgroundColor: IUProperty<string>;
  alignLeftCenter: IUProperty<boolean>;
  topWave: IUProperty<boolean>;
  bottomWave: IUProperty<boolean>;
  bottomCurve: IUProperty<boolean>;

  rteStyleSettingsComposition?: IRteStyleSettings;
  titleStyleSettings?: ITitleStyleSettings;
}

@Component({
  selector: 'app-rte-panel',
  templateUrl: './rte-panel.component.html',
  styleUrls: ['./rte-panel.component.less']
})
export class RtePanelComponent {
  @Input() data: IRtePanelData;
  @ViewChild('panelElRef', { static: false }) panelElRef: ElementRef<HTMLElement>;
  @ViewChild('titleEl', { static: false }) titleEl: ElementRef<HTMLElement>;
  @ViewChild('descriptionEl', { static: false }) descriptionEl: ElementRef<HTMLElement>;
  @ViewChild('titleWrapperEl', { static: false }) titleWrapperEl: ElementRef<HTMLElement>;
  @ViewChild('contentEl', { static: false }) contentEl: ElementRef<HTMLElement>;
  options: AnimationOptions;

  scrollPosition: number = null;

  @HostListener('window:scroll', []) onWindowScroll() {
    this.scrollPosition = window.pageYOffset;
    if ((this.scrollPosition + window.outerHeight) > this.panelElRef.nativeElement.offsetTop) {
      this.loadMedia();
    }
  }

  ngOnInit() {
    if (this.data && this.data.animationUrl && this.data.animationUrl.value) {
      this.options = {
        path: this.data.animationUrl.value,
        autoplay: true,
        loop: true
      };
    }
  }

  ngAfterViewInit() {
    this.scrollPosition = window.pageYOffset;
    if ((this.scrollPosition + window.outerHeight) > this.panelElRef.nativeElement.offsetTop) {
      this.loadMedia();
    }

    this.setCustomThemeProperties(this.data);
    applyTitleSettings(this.data, this.titleEl);
    applyRteSettings(this.data, this.descriptionEl);
  }

  loadMedia() {
    if (this.panelElRef && this.panelElRef.nativeElement && this.data && this.data.backgroundImage && this.data.backgroundImage.value) {
      this.panelElRef.nativeElement.style.backgroundImage = 'url(' + this.data.backgroundImage.value.src + ')';
      this.panelElRef.nativeElement.style.backgroundSize = 'cover';
      this.panelElRef.nativeElement.style.backgroundRepeat = 'no-repeat';
      this.panelElRef.nativeElement.style.backgroundPosition = 'bottom 40% center'
    }
  }

  private setCustomThemeProperties(d: IRtePanelData) {
    if (d.backgroundColor && d.backgroundColor.value) {
      this.panelElRef.nativeElement.style.setProperty('--rte-background-color', d.backgroundColor.value);
    }
  }
}

